import { Divider, Stack, Typography } from '@optimus-web/core';

interface ContentItemProps {
    label: React.ReactNode;
    value: string | React.ReactNode;
    last: boolean;
}

export const DocumentDetailsItem = ({ label, value, last }: ContentItemProps) => (
    <Stack as="li" vertical spacing="150">
        <Stack alignment="center" distribution="space-between" spacing="100">
            <Typography textStyle="bodyMedium" variant="secondary" as="div">
                {label}
            </Typography>
            <Typography textStyle="bodyMediumStrong" as="div">
                {value}
            </Typography>
        </Stack>
        {!last && <Divider />}
    </Stack>
);
